import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { tbCustomerFeaturesLeft, tbCustomerFeaturesRight } from "../tbModulesData";
import TbImagePlaceholder from "./TbImagePlaceholder";

const FeatureList: React.FC<{ items: string[]; align: "left" | "right" }> = ({ items, align }) => (
  <ul className={`tb-customer__list tb-customer__list--${align}`}>
    {items.map((item, index) => (
      <motion.li
        key={item}
        initial={{ opacity: 0, x: align === "left" ? -12 : 12 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4, delay: index * 0.04 }}
      >
        <span className="tb-customer__dot" aria-hidden="true" />
        {item}
      </motion.li>
    ))}
  </ul>
);

const TbCustomerAppSection: React.FC = () => {
  return (
    <section className="tb-customer" aria-labelledby="tb-customer-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2
            id="tb-customer-title"
            className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline"
          >
            Taxi Hailing Customer App
          </h2>
          <p className="tb-customer__lead">
            A highly-interactive taxi app for customers with user-friendly UI/UX.
          </p>
        </AnimatedSection>

        <div className="tb-customer__layout">
          <FeatureList items={tbCustomerFeaturesLeft} align="left" />

          <AnimatedSection className="tb-customer__center" delay={0.1}>
            <TbImagePlaceholder
              variant="phone"
              label="Customer App"
              hint="Map · Payment mode · Ride booking"
              className="tb-customer__placeholder"
            />
          </AnimatedSection>

          <FeatureList items={tbCustomerFeaturesRight} align="right" />
        </div>
      </div>
    </section>
  );
};

export default TbCustomerAppSection;
